import axios, {AxiosResponse} from "axios";
import {CalendarResponse} from "../models/APIModels";

const instance = axios.create({
    //baseURL: 'http://127.0.0.1:8000/api/',
    baseURL: 'https://xn--90aa5bhn.xn--p1ai/api/',
})

export class CalendarService {
    static async getEvents(): Promise<AxiosResponse<CalendarResponse>> {
        return instance.get<CalendarResponse>('calendar/')
    }
}
